import React from 'react';

import {SelectBaseRTK} from 'app/components/general/SelectBase/SelectBaseRTK';
import {convertLocationParamsToFetchParams} from 'app/roles/actions';
import {useGetRoles} from 'app/roles/api';
import {getRoleLabel} from 'app/roles/utils';
import {getContentType} from 'app/utils/content-type';

import type {ActionMeta} from 'app/components/general/SweetReactSelect';
import type {ComponentProps} from 'react-select';
import type {BasicRoleSerializedType} from 'sweet-types';

const roleCt = getContentType('role');

type CommonProps = {
  fetchIds?: Array<number | string>;
  placeholder: string;
  disabled?: boolean;
  lazyFetch?: boolean;
  params?: Record<string, string | number>;
  addFirstOption?: BasicRoleSerializedType;
  typeIcon?: null | string | ((role: BasicRoleSerializedType) => string | null);
  selectProps?: Record<string, any>;
  components?: ComponentProps;
};

type SingleProps = CommonProps & {
  selected: BasicRoleSerializedType | null;
  onChange: (
    roles: BasicRoleSerializedType,
    meta: ActionMeta<BasicRoleSerializedType>
  ) => Promise<unknown>;
};

export const RolesSelectSingle = ({
  selectProps = {},
  typeIcon = roleCt.icon,
  ...other
}: SingleProps) => {
  selectProps.getLabel = getRoleLabel;

  return (
    <SelectBaseRTK
      isMulti={false}
      isRTKFetcher={true}
      getLabel={getRoleLabel}
      useDataHook={useGetRoles}
      paramsConverter={convertLocationParamsToFetchParams}
      selectProps={selectProps}
      typeIcon={typeIcon}
      {...other}
    />
  );
};

type MultiProps = CommonProps & {
  selected: Array<BasicRoleSerializedType>;
  onChange: (
    roles: Array<BasicRoleSerializedType>,
    meta: ActionMeta<BasicRoleSerializedType>
  ) => Promise<unknown>;
};

export const RolesSelectMulti = ({
  selectProps = {},
  typeIcon = roleCt.icon,
  ...other
}: MultiProps) => {
  selectProps.getLabel = getRoleLabel;

  return (
    <SelectBaseRTK
      isMulti={true}
      isRTKFetcher={true}
      getLabel={getRoleLabel}
      useDataHook={useGetRoles}
      paramsConverter={convertLocationParamsToFetchParams}
      selectProps={selectProps}
      typeIcon={typeIcon}
      {...other}
    />
  );
};
